//IMPORT HEADER
import anchor_header from "./components/layouts/header";
//IMPORT FOOTER
import anchor_footer from "./components/layouts/footer";
var assessment_image='https://elearningindustry.com/wp-content/uploads/2021/05/end-to-end-assessment-supporting-the-student-education-journey.png';

export default {
    name: 'App',

    // metaInfo: {
    //     title: 'Anchor Group Assessments',
    //     htmlAttrs: {
    //       lang: 'en-US'
    //     },
    //     meta: [
    //       { charset: 'utf-8' },
    //       { name: 'description', content: 'The Anchor assessments examine the level of maturity of an organization is crucial strategic and functional areas. The Assessments are built on a circular principle that great organizations continuously evaluate, measure, and tweak.' },
    //       { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    //       {name:'image', property:'og:image', content:'https://s3.amazonaws.com/mentoring.redesign/s3fs-public/male-CEO-business-team.jpg'}
    //     ]
    //   },
    created() {
    
        document.title = "Anchor Group Assessments";
    },
    components: {
        anchor_header,
        anchor_footer
    },
    mounted() {
        
        this.init();
    },
    methods: {
        init() {
            this.initDropdownHover();
            this.windowScroll();
            this.initMenuactive();
        },
        /*----DROPDOWN HOVER JS-----*/
        initDropdownHover() {
            $(".dropdown").on('mouseover', function () {
                $('.dropdown-menu', this).stop(true, true).fadeIn("fast");
                $(this).addClass('open');
            });
            $(".dropdown").on('mouseleave', function () {
                $('.dropdown-menu', this).stop(true, true).fadeOut("fast");
                $(this).removeClass('open');
            });
        },
        initMenuactive() {
            $(".navbar-collapse .nav-item").click(function () {
                $('.navbar-collapse').children().find('.nav-item').removeClass('active');
                $(this).addClass('active');
            });
        },
        /*----ONSCROLL JS-----*/
        windowScroll() {
            var self = this;
            $(window).on("scroll", function () {
                self.initSectionScroll();
            });
        },
        /*----SECTION SCROLL JS-----*/
        initSectionScroll() {
            $(window).scrollTop() >= 20 ? $("nav").addClass("sticky-header") : $(".sticky").removeClass("sticky-header");
        }
    }
}